module.exports = __webpack_public_path__ + "assets/LTangent.6fcd18bd63146070ea9252bab01d2d4c.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/LTangent.gmt
// module id = 967
// module chunks = 0